import React, { InputHTMLAttributes, RefCallback } from 'react';
import { IconList } from '../Icon';
import { Icon } from '../Icon';
import styles from './Checkbox.module.scss';
import { Inline } from 'components/layout';

export type Props = {
  size?: 'sm' | 'md' | 'lg';
  intermediate?: boolean;
  isError?: boolean;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'type'>;

const Checkbox = (
  {
    className,
    children,
    size = 'sm',
    intermediate = false,
    isError,
    ...props
  }: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const classes = [styles.CheckboxWrapper];
  if (size) classes.push(styles[size]);
  if (isError) classes.push(styles.isError);
  if (intermediate) classes.push(styles.intermediate);
  if (className) classes.push(className);

  // The <label> is required so that click events are
  // sent to the <input> which is hidden. The .StylngHook
  // is used to position the custom checkbox styling and
  // respond to changes of state in the <input>
  return (
    <div>
      <Inline
        alignX="left"
        spacing={2}
        component="label"
        className={classes.join(' ')}
      >
        <input
          type="checkbox"
          className={styles.Checkbox_input}
          ref={ref as React.RefObject<HTMLInputElement>}
          {...props}
        />

        <div className={styles.Checkbox}>
          <Icon
            className={styles.Check}
            icon={intermediate ? IconList.solid.faDash : IconList.solid.faCheck}
          />
          <div className={styles.FocusRing} />
        </div>
        {children}
      </Inline>
    </div>
  );
};

const forwardedCheckbox = React.forwardRef<any, Props>(Checkbox) as React.FC<
  Props & { ref?: React.RefObject<any> | RefCallback<any> }
>;

export { forwardedCheckbox as Checkbox };
